import { POST_TRANSLATION_LANGUAGES } from "../services/postTranslationApi";

const SUPPORTED_LANGUAGE_SET = new Set(POST_TRANSLATION_LANGUAGES);
const URL_PATTERN =
  /(?:\b(?:https?:\/\/|www\.)\S+|\b(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}(?:\/\S*)?)/giu;
const HASHTAG_PATTERN = /(^|\s)#[^\s#]+/gu;
const KEYCAP_EMOJI_PATTERN = /[0-9#*]\uFE0F?\u20E3/gu;
const MEANINGFUL_CHARACTER_PATTERN = /[\p{L}\p{N}]/u;

export function normalizePostTranslationLanguage(language) {
  const normalized = String(language || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/, 1)[0];
  return SUPPORTED_LANGUAGE_SET.has(normalized) ? normalized : "";
}

export function isPostTranslationLanguageSupported(language) {
  return Boolean(normalizePostTranslationLanguage(language));
}

export function isCaptionTranslationEligible(caption) {
  if (typeof caption !== "string" || !caption.trim()) {
    return false;
  }

  const meaningfulRemainder = caption
    .replace(KEYCAP_EMOJI_PATTERN, " ")
    .replace(URL_PATTERN, " ")
    .replace(HASHTAG_PATTERN, " ");
  return MEANINGFUL_CHARACTER_PATTERN.test(meaningfulRemainder);
}

export function isPostTypeTranslationEligible(postType) {
  const normalized = String(postType || "").trim().toLowerCase();
  return normalized === "catch" || normalized === "opinion";
}
